import {
  FeatureFlagDataProvider,
  FeatureFlagProvider,
  useFeatureFlagDataProvider,
} from '@sas/nova-commons/hooks/useFeatureFlag';
import { FC, ReactNode, useMemo } from 'react';
import { BehaviorSubject } from 'rxjs';
import { useBehaviorSubjectValue } from '@sas-dvr/internal-va-react-core/config/utils';

const featureFlagOverrides$ = new BehaviorSubject<ReadonlyMap<string, boolean>>(new Map());
export function setFeatureFlagOverride(feature: string, value: boolean | undefined) {
  const featureFlagOverrides = new Map(featureFlagOverrides$.value);
  if (value === undefined) {
    featureFlagOverrides.delete(feature);
  } else {
    featureFlagOverrides.set(feature, value);
  }
  featureFlagOverrides$.next(featureFlagOverrides);
}

/**
 * Allows VASDK to set nova feature flags while deferring to the host application's
 * FeatureFlagProvider if it exists
 */
export const FeatureFlagOverrideProvider: FC<{
  children: ReactNode;
}> = (props) => {
  const novaProvider = useFeatureFlagDataProvider();
  const featureFlagOverrides = useBehaviorSubjectValue(featureFlagOverrides$);

  const provider = useMemo<FeatureFlagDataProvider>(() => {
    return {
      async isFeatureEnabled(feature) {
        return featureFlagOverrides.get(feature) ?? novaProvider.isFeatureEnabled(feature);
      },
    };
  }, [featureFlagOverrides, novaProvider]);

  return <FeatureFlagProvider value={provider}>{props.children}</FeatureFlagProvider>;
};
